<template>
  <img class="giftee-app-icon" :src="gifteeAppIcon" alt="giftee-app-icon" />
</template>

<script>
import GifteeIcon from '../../../../../images/icons/giftee-app-icon.png'
export default {
  data() {
    return {
      gifteeAppIcon: ''
    }
  },
  mounted() {
    this.gifteeAppIcon = GifteeIcon
  }
}
</script>
<style lang="scss" scoped>
.giftee-app-icon {
  max-width: 100%;
}
</style>
